"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReduxDateTimePicker;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _iconsMaterial = require("@mui/icons-material");
var _DateTimePicker = _interopRequireDefault(require("@mui/lab/DateTimePicker"));
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _CleverApplicationContext = require("../../Providers/CleverApplicationContext");
var _DateRangeIcon;
var _excluded = ["fullWidth", "helperText", "id", "input", "iso", "label", "meta", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ReduxDateTimePicker(_ref) {
  var _meta$data;
  var fullWidth = _ref.fullWidth,
    helperText = _ref.helperText,
    id = _ref.id,
    input = _ref.input,
    iso = _ref.iso,
    label = _ref.label,
    meta = _ref.meta,
    _onChange = _ref.onChange,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var valueRef = (0, _react.useRef)(input.value || null);
  var _useContext = (0, _react.useContext)(_CleverApplicationContext.CleverApplicationContext),
    locale = _useContext.locale;
  var error = meta.touched && (meta.error || !meta.modifiedSinceLastSubmit && (meta == null ? void 0 : (_meta$data = meta.data) == null ? void 0 : _meta$data.submitError) || meta.warning);
  var active = meta.active,
    autofilled = meta.autofilled;
  var handlePopperClick = (0, _react.useCallback)(function () {
    input.onChange(valueRef.current);
    input.onBlur(valueRef.current);
  }, [input]);
  // TODO: Remove when masking bug for different locales is fixed

  var inputFormat;
  var mask;
  if (iso) {
    inputFormat = 'yyyy-MM-dd HH:mm';
    mask = '____-__-__ __:__';
  } else if (locale === 'en-US') {
    inputFormat = 'MM/dd/yyyy HH:mm';
    mask = '__/__/____ __:__';
  } else {
    inputFormat = 'dd/MM/yyyy HH:mm';
    mask = '__/__/____ __:__';
  }
  return /*#__PURE__*/_react.default.createElement(_DateTimePicker.default, (0, _extends2.default)({
    ampm: false,
    autoOk: true,
    dateRangeIcon: _DateRangeIcon || (_DateRangeIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.DateRange, null)),
    id: id,
    inputFormat: inputFormat,
    label: label,
    mask: mask,
    name: input.name,
    onChange: function onChange(date) {
      if (open) {
        // NB! Mui pickers fire additional onChange(previousValue) if closed
        // before all views are completed
        valueRef.current = date;
      } else {
        input.onChange(date);
      }
      if (typeof _onChange === 'function') {
        _onChange(date);
      }
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    onOpen: function onOpen() {
      return setOpen(true);
    },
    PopperProps: {
      onClick: function onClick() {
        return handlePopperClick();
      }
    },
    renderInput: function renderInput(props) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, props, {
        error: !!error,
        fullWidth: fullWidth,
        helperText: error || helperText,
        InputLabelProps: {
          shrink: active || autofilled || !!input.value
        },
        onBlur: function onBlur(e) {
          return input.onBlur(e);
        },
        onFocus: function onFocus(e) {
          return input.onFocus(e);
        }
      }));
    },
    value: input.value || null
  }, other));
}